<template>
	<a-modal
		:visible="visible"
		@ok="handleOk"
		:confirmLoading="confirmLoading"
		@cancel="handleCancel"
		:okButtonProps="{ props: { disabled: disabled } }"
		class="contact-us-dialog"
	>
		<div class="item">
			<p>
				<span class="required">*</span
				>{{ $t('component.contactUs.yourName') }}
			</p>
			<a-input
				:placeholder="$t('component.contactUs.yourName')"
				v-model="form.senderName"
			></a-input>
		</div>
		<div class="item">
			<p>
				<span class="required">*</span
				>{{ $t('component.contactUs.yourEmail') }}
			</p>
			<a-input
				:placeholder="$t('component.contactUs.inputYourEmail')"
				v-model="form.address"
				ref="refEmail"
			></a-input>
		</div>
		<!-- 这两个产品确认不用做多语言 -->
		<div class="item" v-if="accountId == 2517">
			<p>your ID</p>
			<a-input v-model="form.uid" ref="refUid"></a-input>
		</div>
		<div class="item" v-if="accountId == 2517">
			<p>your Server</p>
			<a-input v-model="form.server" ref="refServer"></a-input>
		</div>
		<div class="item">
			<p>
				<span class="required">*</span
				>{{ $t('component.contactUs.yourQuestion') }}
			</p>
			<a-input
				:placeholder="$t('component.contactUs.helpYou')"
				type="textarea"
				:autosize="{ minRows: 6, maxRows: 10 }"
				v-model="form.lastMessage"
			></a-input>
		</div>
	</a-modal>
</template>
<script>
import { contactUs } from '@/api/index';
import { validEmail } from '@/utils/validate';
export default {
	name: 'contactUs',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		appName: {
			type: String,
			default: '',
		},
		gameId: {
			type: Number,
		},
	},
	data() {
		return {
			confirmLoading: false,
			form: {
				senderName: '',
				address: '',
				uid: '',
				server: '',
				lastMessage: '',
				message: '',
				subject: '',
				//
				gameId: 0,
				gameName: '',
				userName: '',
				userId: 0,
				trueName: '',
			},
		};
	},
	watch: {
		appName(val) {
			this.form.gameName = val;
		},
	},
	computed: {
		accountId() {
			return this.$store.state.webchat.accountId;
		},
		disabled() {
			let senderName = this.form.senderName.trim();
			let address = this.form.address.trim();
			let lastMessage = this.form.lastMessage.trim();
			if (senderName === '' || address === '' || lastMessage === '') {
				return true;
			}
			return false;
		},
	},
	methods: {
		handleOk() {
			this.form.gameName = this.appName;
			this.form.gameId = this.gameId;
			this.form.subject = this.form.senderName;
			this.confirmLoading = true;
			let result = validEmail(this.form.address);
			if (!result) {
				this.$message.error(
					this.$t('component.contactUs.emailFormatError')
				);
				this.$refs.refEmail.focus();
				this.confirmLoading = false;
				return;
			}
			let message = this.form.lastMessage;
			if (this.form.uid) {
				message = `${message}\nyour ID:${this.form.uid}`;
			}
			if (this.form.server) {
				message = `${message}\nYour Server:${this.form.server}`;
			}
			this.form.message = message;
			contactUs(this.form)
				.then((res) => {
					this.confirmLoading = false;
					this.handleCancel();
				})
				.catch((err) => {
					this.confirmLoading = false;
				});
		},
		handleCancel() {
			this.$emit('update:visible', false);
			this.resetDialog();
		},
		resetDialog() {
			this.form.senderName = '';
			this.form.address = '';
			this.form.lastMessage = '';
			this.form.message = '';
      this.form.uid = '';
      this.form.server = '';
			this.form.subject = '';
		},
	},
};
</script>
<style lang="scss">
.contact-us-dialog {
	.item {
		margin-bottom: 12px;
		&:last-child {
			margin-bottom: 0;
		}
		.required {
			color: #f56c6c;
			margin-right: 3px;
		}
	}
	p {
		margin-bottom: 5px;
	}
}
</style>
